import React from 'react';
import { CardCarouselWrapper, useRefDimensions } from '@avila-tek/ui/src';
import { Multimedia } from '../../../models';
import ProductImgItem from './ProductImgItem';
import fallbackImg from '../../../public/images/product-card-fallback.png';

interface ProductCarouselProps {
  images: Partial<Multimedia>[];
}

function ProductCarousel({ images }: ProductCarouselProps) {
  const [indexSelected, setIndexSelected] = React.useState(0);
  const [elementToShow, setElementsToShow] = React.useState(4);

  const selectImg = (e: React.MouseEvent<HTMLDivElement>) => {
    const { idx } = e.currentTarget.dataset;
    setIndexSelected(Number(idx));
  };

  // carousel cards refs
  const refs = images.reduce((acc: any, value, index) => {
    acc[index] = React.createRef<HTMLDivElement>();
    return acc;
  }, {});

  const { width: cardWidth } = useRefDimensions(refs[0]);

  return (
    <div className="flex flex-col py-5 lg:py-0  lg:pr-5 ">
      {/* selected image */}
      <div className="w-full">
        <div className="relative z-10 h-[15rem] md:h-[28rem] flex justify-center">
          <img
            className="carousel-img  h-full rounded-lg md:rounded-2xl transition relative object-fill"
            src={images[indexSelected]?.src ?? fallbackImg.src}
            alt={images[indexSelected]?.alt ?? ''}
          />
        </div>
      </div>
      <CardCarouselWrapper
        cardDimension={cardWidth}
        elementsToShow={elementToShow}
      >
        {images.map((img, i) => (
          <div ref={refs[i]} key={`card-${i}`} className="carousel-child">
            <ProductImgItem
              idx={i}
              selectImg={selectImg}
              active={i === indexSelected}
              imgSrc={img?.src ?? fallbackImg.src}
            />
          </div>
        ))}
      </CardCarouselWrapper>
    </div>
  );
}

export default ProductCarousel;
